import useViewsSelector from "views/stores/useViewsSelector";
import { selectGlobalOverride } from "views/logic/slices/searchExecutionSelectors";
const useGlobalOverride = () => useViewsSelector(selectGlobalOverride);
export default useGlobalOverride;
